export const BASE_URL =
  import.meta.env.MODE === 'development'
    ? '/api/'
    : import.meta.env.VITE_APP_API_URL;

export const MATOMO_CONTAINER_NAME =
  import.meta.env.MODE === 'development'
    ? 'https://cdn.matomo.cloud/myexco.matomo.cloud/container_dev.js'
    : import.meta.env.VITE_APP_MATOMO_CDN_URL;

export const ACCESS_TOKEN_KEY = 'spinfi-accessToken';
export const REFRESH_TOKEN_KEY = 'spinfi-refreshToken';

export const WAIBI_ACCESS_TOKEN = 'waibi-token';
export const WAIBI_REFRESH_TOKEN = 'waibi-refresh-token';

export const TOKEN_ENDPOINTS = {
  LOGIN: 'auth/login',
  REFRESH: '/auth/refresh',
  CHANGE_PASSWORD: 'auth/change-password',
  TEMPORARY_CHANGE_PASSWORD: 'clients',
};

export const FACT_MEETING_FORM_URL =
  import.meta.env.MODE === 'development'
    ? 'https://outlook.office365.com/owa/calendar/TestBookinsplanning@exco.fr/bookings/'
    : 'https://outlook.office365.com/owa/calendar/ExcoFSO%40exco.fr/bookings/';
